<div class="relative h-screen">

  <nav class="fixed w-full z-50 bg-gradient-to- from-primary-50 to-transparent transition-all duration-300 bg-white/80 h-20 bg-transparent backdrop-blur-sm shadow-md shadow-slate-100"
       aria-label="Main Navigation">
    <div class="!max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
      <div class="flex items-center justify-between h-full">
        <div class="flex-shrink-0 flex items-center space-x-2 cursor-pointer outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-primary-400">

            <span class="font-extrabold text-3xl flex gap-2 items-center text-primary-900 border border-dotted p-3 rounded-xl">
              <img src="assets/images/emblem.png" class="w-6 md:w-8" alt="">
              <!--              <span class="tracking-[2px]">LOGIN</span>-->
            </span>

        </div>

        <div class="block">
          <div class="ml-10 flex items-center space-x-8">

            <button [routerLink]="['']" class="ml-4 flex items-center justify-center gap-2 px-6 py-2.5 rounded-full text-sm font-bold transition-all transform
              hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500
              bg-primary-600 text-white hover:bg-primary shadow-xl shadow-slate-900/10">
              <div class="-mb-1"><mat-icon class="p-0 m-0">home</mat-icon></div>
              <div>Home</div>
            </button>

          </div>

        </div>

      </div>
    </div>

  </nav>

  <main id="main-content position-relative">

    <section id="top"
             class="relative overflow-hidden z-0 h-screen flex flex-col justify-center px-4 md:sticky md:top-0"
             aria-label="Hero">

      <div class="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div
          class="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-primary-100/30 rounded-full blur-[100px] animate-blob"
        ></div>
        <div
          class="absolute top-[20%] -right-[10%] w-[40%] h-[60%] bg-secondary-100/30 rounded-full blur-[100px] animate-blob animation-delay-2000"
        ></div>
        <div
          class="absolute -bottom-[20%] left-[20%] w-[50%] h-[50%] bg-accent-100/20 rounded-full blur-[100px] animate-blob animation-delay-4000"
        ></div>
      </div>

      <div class="absolute inset-x-0 top-0 h-full pointer-events-none
                bg-gradient-to-b from-white dark:from-gray-900 via-white dark:via-gray-900 to-transparent">
      </div>

      <div class="!max-w-7xl mx-auto w-full relative">

        <div class="bg-transparent min-h-screen flex items-center justify-center">
          <div class="bg-white w-full lg:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center relative">

            <span class="font-extrabold w-full mb-2 text-3xl flex gap-2 items-center justify-center text-primary-900 border border-dotted p-3 rounded-xl">
              <img src="assets/images/emblem.png" class="w-6 md:w-8" alt="">
              <span class="tracking-[2px]">GISP</span>
            </span>

            <div class="check-mail rounded-full p-2 h-20 w-20 flex items-center justify-center bg-primary-50">
              <mat-icon class="h-full w-full" svgIcon="message"></mat-icon>
            </div>

            <div class="flex flex-col items-center text-center mb-4 justify-center gap-2 p-4 border-b border-b-slate-200 w-full">
                <span class="text-gray-dark">Check your Email <br>
                 <b>We have sent password reset instructions</b></span>
            </div>

            <div class="w-full">
              <div class="w-full mt-3">
                <div class="w-full mb-3">
                  <button routerLink="/login" class="w-full" mat-raised-button color="primary">{{ 'Back To Log In'  }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

  </main>

  <app-system-footer></app-system-footer>

</div>
